import { useTheme } from '../components/styles/styles';

export const GreyClockIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7334 10.8C10.8 10.8778 10.8889 10.9167 11 10.9167C11.1111 10.9167 11.2056 10.8722 11.2834 10.7834C11.3611 10.7056 11.4 10.6111 11.4 10.5C11.4 10.3889 11.3611 10.2945 11.2834 10.2167L8.91669 7.85002V4.86669C8.91669 4.76669 8.88058 4.68058 8.80835 4.60835C8.73613 4.53613 8.64446 4.50002 8.53335 4.50002C8.42224 4.50002 8.33335 4.53613 8.26669 4.60835C8.20002 4.68058 8.16669 4.77224 8.16669 4.88335V7.96669C8.16669 8.03335 8.1778 8.09169 8.20002 8.14169C8.22224 8.19169 8.25558 8.24446 8.30002 8.30002L10.7334 10.8ZM8.50002 14.3334C7.63335 14.3334 6.81391 14.1667 6.04169 13.8334C5.26946 13.5 4.59724 13.0472 4.02502 12.475C3.4528 11.9028 3.00002 11.2306 2.66669 10.4584C2.33335 9.68613 2.16669 8.86669 2.16669 8.00002C2.16669 7.13335 2.33335 6.31391 2.66669 5.54169C3.00002 4.76946 3.4528 4.09724 4.02502 3.52502C4.59724 2.9528 5.26946 2.50002 6.04169 2.16669C6.81391 1.83335 7.63335 1.66669 8.50002 1.66669C9.36669 1.66669 10.1861 1.83335 10.9584 2.16669C11.7306 2.50002 12.4028 2.9528 12.975 3.52502C13.5472 4.09724 14 4.76946 14.3334 5.54169C14.6667 6.31391 14.8334 7.13335 14.8334 8.00002C14.8334 8.86669 14.6667 9.68613 14.3334 10.4584C14 11.2306 13.5472 11.9028 12.975 12.475C12.4028 13.0472 11.7306 13.5 10.9584 13.8334C10.1861 14.1667 9.36669 14.3334 8.50002 14.3334Z"
        fill={theme.text.disabled2}
      />
    </svg>
  );
};
